import React, { useEffect, useState } from "react";
import { worldAPI } from "../../../../engine/modules/world/worldAPI";
import GridSettingsSection from "../Popups/editor_v2/world/GridSettingsSection.js";

function GridFloorSettings() {
  const [gridTextureRepeat, setGridTextureRepeat] = useState(1);
  const [gridVisible, setGridVisible] = useState(null);
  const [gridColorMode, setGridColorMode] = useState("light");

  const getGridSettings = () => {
    const settings = worldAPI.getAllSettings();
    setGridTextureRepeat(settings.grid.tiling);
    setGridVisible(settings.grid.visible);
    setGridColorMode(settings.grid.colorMode);
  };

  useEffect(() => {
    getGridSettings();

    const unsubscribe = worldAPI.subscribe((change) => {
      if (change.type === "grid") {
        getGridSettings();
      }
    });

    return unsubscribe || (() => {});
  }, []);

  return (
    <div className="GridFloorSettings">
      <GridSettingsSection
        title={null}
        compact
        gridTextureRepeat={gridTextureRepeat}
        gridVisible={gridVisible}
        gridColorMode={gridColorMode}
        getSettings={getGridSettings}
        setGridVisible={(state) => {
          worldAPI.setGridVisible(state);
          getGridSettings();
        }}
      />
    </div>
  );
}

export default GridFloorSettings;
